import React from 'react';
import { ARROW_SIZE } from '../../constants/relationship-renderer';
import { getArrowheadPoints, getCounterScaleOnlyStyle } from '../../utils/relationship-renderer';
type PropsT = {
  target: [number, number];
  angle: number;
  color: string;
};
const EdgeArrowhead = ({
  target,
  angle,
  color
}: PropsT) => <polygon points={getArrowheadPoints(target, angle, ARROW_SIZE)} fill={color} style={getCounterScaleOnlyStyle(target[0], target[1])} />;
export default EdgeArrowhead;